const Form008TC = {
    stepName: {
        importantNotes: "重要提示",
        application: "申請訊息",
        confirmation: "確認",
    },
    importantNotes: {
        title: "重要事項",
        note: "獲學校推薦的公益少年團團員需填妥電子申請表，並提交正面半身近照及團員記錄冊予所屬學校的公益少年團負責教師，以便安排上載相關文件。",
    },
    notes: {
        importantNotes:
            "獲學校推薦的公益少年團團員需填妥電子申請表，並提交正面半身近照及團員記錄冊予所屬學校的公益少年團負責教師，以便安排上載相關文件。",
        noteOne: "本人已於",
        year: "年",
        month: "月",
        day: "日",
        noteTwo: "完成團員獎勵計劃的",
        level: "級（",
        chapter: "章）級別。",
        statementOne: "收集申請者個人資料聲明",
        blackCircle: "●",
        statementTwo:
            "學生所提交的個人資料及相關文件（如個人資料表及證件影印本等），將用於處理參加交流團之用。參加者如未能提供所需資料，有關申請將不獲受理。",
        statementThree:
            "教育局會按需要，將個人資料送交獲授權處理的航運機構、酒店、旅行社、保險公司或相關單位，以便安排學習、交流、參訪、住宿、交通及緊急醫療等事宜。",
        statementFour:
            "所有個人資料及相關文件（包括個人資料表及證件影印本等）將於交流團完結後銷毀。",
        statementFive:
            "獲提名參加者有權根據《個人資料（私隱）條例》（香港特別行政區法例第 <b>486</b> 章）第 <b>18</b> 和 <b>22</b> 條，以及附表 <b>1</b> 第 <b>6</b> 項原則規定，查閱和更正所提供的個人資料。如對參加交流團所收集的個人資料有任何查詢，包括查閱及更正資料，請聯絡香港灣仔皇后大道東 <b>213</b> 號胡忠大廈 <b>11</b> 樓 <b>1141</b> 室教育局公益少年團辦事處（電話：<b>2892 6660</b>）。",
        // pography_a: "(a) 辦理與聘用有關的事宜；",
        // pography_b: "(b) 處理發放薪金津貼，以及計算公積金的供款和贈款；",
        // pography_c: "(c) 進行核數工作；",
        // pography_d: "(d) 進行研究及統計資料，以便規劃教育服務；",
        // pography_e: "(e) 處理有關教育專業人員發展的事宜；",
        // pography_f:
        //     "(f) 執行《教育條例》、《教育規例》及附屬《補助/津貼學校公積金規則》(第279章)。",
        // pographyOne:
        //     "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        // pographyTwo:
        //     "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
        // pographyThree:
        //     "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        // pographyFour:
        //     "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
    },
    title: {
        headerOne:
            "{{schoolyear}}年公益少年團傑出團員{{country}}交流團提名表格（團員適用）",
        headerTwo: "家長╱監護人同意書",
        headerThree: "收集申請者個人資料聲明",
        recommendation:
            "{{schoolyear}}年公益少年團傑出團員{{country}}交流團校長推薦書（團員適用）",
    },
    genderOption: {
        M: "男",
        F: "女",
    },
    joinOption: {
        yes: "有",
        no: "沒有",
    },
    languageOption: {
        gd: "廣東話",
        en: "英語",
        cn: "普通話",
        korean: "韓語",
        other: "其他",
    },
    newLanguageOption: {
        gd: "廣東話",
        en: "英語",
        cn: "普通話",
        other: "其他",
    },
    levelOption: {
        1: "小學基本",
        2: "小學初",
        3: "小學中",
        4: "小學高",
        5: "中學基本",
        6: "中學初",
        7: "中學中",
        8: "中學高",
        9: "三等榮譽",
        10: "二等榮譽",
        11: "一等榮譽",
    },
    chapterOption: {
        1: "粉黃",
        2: "粉綠",
        3: "粉橙",
        4: "粉紫",
        5: "黃",
        6: "綠",
        7: "橙",
        8: "紫",
        9: "藍星榮譽徽",
        10: "白星榮譽徽",
        11: "紅星榮譽徽",
    },
    languageLevelOption: {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
    },
    careForOption: {
        yes: "需要",
        no: "不需要",
    },
    label: {
        termsConditions: "本人已閱讀、理解及同意上述條款及條件。",
        nameCn: "獲提名團員中文姓名",
        nameEn: "獲提名團員英文姓名",
        sex: "性別",
        dateBirth: "出生日期",
        hkId: "身份證號碼",
        recentPhoto: "正面半身近照",
        award: "團員紀錄冊",
        stuTel: "學生聯絡電話",
        school: "就讀學校",
        grade: "班級",
        schoolAddress: "學校地址",
        schoolTel: "學校電話",
        schoolFax: "學校傳真",
        one: "本人已於___年___月___日",
        two: "完成團員獎勵計劃的___級（___章） 級別。",
        language: "能操語言",
        other: "其他（請註明）",
        interests: "興趣/專長",
        experience: "簡述參與公益少年團一項難忘的服務經驗",
        isJoinActivity: "曾否參加境外交流活動",
        projectName: "活動名稱",
        projectDate: "日期",
        isApply: "有否同時申請本學年暑假期間舉行的其他境外交流團",
        projectApplyName: "活動名稱",
        dateApply: "日期",
        applicantSign: "獲提名團員簽署",
        agreeOne: "本人同意敝子弟",
        applyName: "（獲提名團員姓名）",
        agreeName: "子弟",
        join: "參加",
        joinOne: "年公益少年團傑出團員",
        joinTwo:
            "交流團，並承諾一旦獲選，定當督促其出席出發前所有訓練及交流結束後的小組報告匯報日，以及在旅途中遵從導師和領隊的指示，並完成有關交流成果的小組報告",
        group: "交流團",
        parentsName: "家長/監護人姓名",
        parentsTel: "家長聯絡電話",
        relation: "與獲提名團員的關係",
        schoolName: "學校名稱",
        nameOfApplicantCn: "獲提名團員姓名（中文）",
        nameOfApplicantEn: "獲提名團員姓名（英文）",
        conduct: "獲提名團員的品行",
        performance: "獲提名團員在公益少年團的表現（例如做事的積極性、態度等）",
        cnLevel: "普通話",
        enLevel: "英語",
        koreanLevel: "韓語",
        careFor: "獲提名團員於參與面試或境外交流時是否需要特別照顧",
        careDesc: "請註明",
        otherComments: "其他評語",
        nameOfPrincipal: "校長姓名",
        principalTel: "學校電話",
        approverEmailAddress: "家長電郵",
        emailAddress: "電郵地址",
        ability: "獲提名團員的語言能力（1 分最低至 5 分最高）",
        sentence:
            "學校在推薦團員參加公益少年團傑出團員交流團時，請考慮該團員以往曾否參加境外交流活動，並優先推薦未曾參加過境外交流活動的團員。",
    },
    errorMsg: {
        relation: "關係",
    },
    signature: {
        approver:
            "這張表格已被發送到批核方，待批核方發送電郵至申請者電郵，申請者再依從電郵指示登入以完成整個申請。",
    },
};
export default Form008TC;
